import { CREATOR_CLIENT_KEY } from '../../../model/constants'
import getCurrentCreatorClientSelect from '../get-current'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

const getCurrentCreatorClientIdSelect = state => {
  const creatorClient = (
    getCurrentCreatorClientSelect(state)
  )
  return getValueReduxUtil(creatorClient, CREATOR_CLIENT_KEY.CLIENT_ID)
}

export default getCurrentCreatorClientIdSelect
